import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class SaldoDocumentoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSaldoDocumentoCliente(rut_emisor, sucursal_codigo, cliente_proveedor_rut, pagado, callback) {
        const inputParams = {
            entidad: {
                rut_emisor,
                sucursal_codigo,
                cliente_proveedor_rut,
                pagado,
            },
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType) {
            saldo_documento {
              obtenerSaldoDocumentoCliente(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    cliente_proveedor_rut
                    fecha_emision
                    fechaVencimientoDocto
                    vendedor_codigo
                    vendedor_nombre
                    recorrido_codigo
                    recorrido_estado
                    codigo_estado_recorrido
                    protesto_cheque_codigo
                    reversa_pago_codigo
                    faltante_excedentes_codigo
                    tipo_pago
                    ref_folio
                    ref_doc
                    pago_codigo
                    pagado
                    monto
                    saldo
                    pago
                    deuda
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerSaldoDocumentoCliente;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTotalSaldoDocumentoCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pagoDTOInputType) {
            saldo_documento {
              obtenerTotalSaldoDocumentoCliente(entidad: $entidad) {
                respuesta {
                  total_monto
                  total_pago
                  total_abono
                  total_deuda
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerTotalSaldoDocumentoCliente;
            callback({ mensajes, respuesta });
        });
    }
    obtenerClientesMorosos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $rutEmpresa: Decimal
            $fechaInicio: String
            $fechaTermino: String
            $cliente_proveedor_rut: Decimal
            $vendedor_codigo: Decimal
            $todosClientes: Boolean
            $todosVendedores: Boolean
            $generaExcel: Boolean
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            saldo_documento {
              obtenerClientesMorosos(
                rutEmpresa: $rutEmpresa
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                cliente_proveedor_rut: $cliente_proveedor_rut
                vendedor_codigo: $vendedor_codigo
                todosClientes: $todosClientes
                todosVendedores: $todosVendedores
                generaExcel: $generaExcel
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  totalPaginas
                  cantidadRegistrosPorPagina
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    razonSocialCliente
                    nombreTipoDocto
                    folio
                    fecha_emision
                    fechaVencimientoDocto
                    vendedor_nombre
                    vendedor_codigo
                    total_monto
                    pago
                    saldo
                    dv0107
                    dv0815
                    dv1630
                    dv30mas
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerClientesMorosos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerClientesMorososExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $rutEmpresa: Decimal
            $fechaInicio: String
            $fechaTermino: String
            $cliente_proveedor_rut: Decimal
            $vendedor_codigo: Decimal
            $todosClientes: Boolean
            $todosVendedores: Boolean
            $generaExcel: Boolean
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            saldo_documento {
              obtenerClientesMorosos(
                rutEmpresa: $rutEmpresa
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                cliente_proveedor_rut: $cliente_proveedor_rut
                vendedor_codigo: $vendedor_codigo
                todosClientes: $todosClientes
                todosVendedores: $todosVendedores
                generaExcel: $generaExcel
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    nombreArchivoExcel
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerClientesMorosos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDocumentoPorCobrarClienteResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteDocPorCobrarClienteResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rut_emisor
                    sucursal_codigo
                    cliente_proveedor_rut
                    razonSocialCliente
                    documento
                    folio
                    fecha_emision
                    fechaVencimientoDocto
                    direccion_codigo
                    direccion_nombre
                    comuna_codigo
                    comuna_nombre
                    localidad
                    bloqueado
                    bloqueado_protesto
                    telefono
                    vendedor_codigo
                    vendedor_nombre
                    monto
                    abono
                    saldo
                  }
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPorCobrarClienteResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDocumentoPorCobrarClienteResumenExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteDocPorCobrarClienteResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    nombreArchivoExcel
                  }
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPorCobrarClienteResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDocumentoPorCobrarClienteDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteDocPorCobrarClienteDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rut_emisor
                    sucursal_codigo
                    cliente_proveedor_rut
                    razonSocialCliente
                    documento
                    folio
                    fecha_emision
                    fechaVencimientoDocto
                    direccion_codigo
                    direccion_nombre
                    comuna_codigo
                    comuna_nombre
                    localidad
                    bloqueado
                    telefono
                    vendedor_codigo
                    vendedor_nombre
                    monto
                    abono
                    saldo
                  }
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPorCobrarClienteDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDocumentoPorCobrarClienteDetalleExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteDocPorCobrarClienteDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    nombreArchivoExcel
                  }
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteDocPorCobrarClienteDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteSaldoClientes(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            saldo_documento {
              obtenerReporteSaldoClientes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    razonSocialCliente
                    telefono
                    saldo
                    condicion_pago_nombre
                    tipo_cobro_nombre
                    vendedores
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteSaldoClientes;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteSaldoClientesExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: saldo_documentoInputType) {
            saldo_documento {
              obtenerReporteSaldoClientes(entidad: $entidad, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  registros {
                    nombreArchivoExcel
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.obtenerReporteSaldoClientes;
            callback({ mensajes, respuesta });
        });
    }
    AjusteSecilloCuentaCorrienteCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: saldo_documentoInputType) {
            saldo_documento {
              ajusteSecilloCuentaCorrienteCliente(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  registros {
                    codigo
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                    cliente_proveedor_rut
                    fecha_emision
                    fechaVencimientoDocto
                    vendedor_codigo
                    vendedor_nombre
                    recorrido_codigo
                    recorrido_estado
                    protesto_cheque_codigo
                    reversa_pago_codigo
                    faltante_excedentes_codigo
                    tipo_pago
                    ref_folio
                    ref_doc
                    pago_codigo
                    pagado
                    monto
                    saldo
                    pago
                    deuda
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.saldo_documento.ajusteSecilloCuentaCorrienteCliente;
            callback({ mensajes, respuesta });
        });
    }
}
SaldoDocumentoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SaldoDocumentoService_Factory() { return new SaldoDocumentoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: SaldoDocumentoService, providedIn: "root" });
